/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import * as TriDictionaryApi from "./api/TriDictionaryApi";
import { TriDictionaryProvider } from "./TriDictionaryProvider";
import { withTriDictionary } from "./withTriDictionary";

const BASE_LANGUAGE_ID = 1;

async function getTranslatedMessages(messages, tag, languageId, refresh) {
  if (languageId === BASE_LANGUAGE_ID) return messages;

  try {
    const dictionary = await TriDictionaryApi.requestTranslatedDictionary(
      Object.values(messages),
      tag,
      languageId,
      refresh
    );
    return buildTranslatedMessageSet(messages, dictionary);
  } catch (error) {
    throw new RequestTranslatedDictionaryException();
  }
}

function buildTranslatedMessageSet(messages, dictionary) {
  const result = {};
  for (const key in messages) {
    const base = messages[key];
    result[key] = dictionary[base];
  }
  return result;
}

function RequestTranslatedDictionaryException() { /* override */ }

export {
  TriDictionaryApi,
  getTranslatedMessages,
  RequestTranslatedDictionaryException,
  TriDictionaryProvider,
  withTriDictionary,
};
